var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeedEmpty = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 173,
  height: 92,
  viewBox: "0 0 173 92",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F3F7FF",
  d: "M95.2 18.41c3.093 0 5.6 2.508 5.6 5.6 0 3.093-2.507 5.6-5.6 5.6h51.2c3.093 0 5.6 2.508 5.6 5.6 0 3.093-2.507 5.6-5.6 5.6H164c3.093 0 5.6 2.508 5.6 5.6 0 3.093-2.507 5.6-5.6 5.6h-15.2c-3.093 0-5.6 2.508-5.6 5.6 0 3.093 2.507 5.6 5.6 5.6h4.8c3.093 0 5.6 2.508 5.6 5.6 0 3.093-2.507 5.6-5.6 5.6H112c-.412 0-.813-.044-1.2-.129-.387.085-.788.13-1.2.13H36.8c-3.093 0-5.6-2.508-5.6-5.6 0-3.093 2.507-5.6 5.6-5.6H5.6c-3.093 0-5.6-2.508-5.6-5.6 0-3.093 2.507-5.6 5.6-5.6h32c3.093 0 5.6-2.508 5.6-5.6 0-3.093-2.507-5.6-5.6-5.6h-20c-3.093 0-5.6-2.508-5.6-5.6 0-3.093 2.507-5.6 5.6-5.6h32c-3.093 0-5.6-2.508-5.6-5.6 0-3.093 2.507-5.6 5.6-5.6h45.6zm72 44.8c3.093 0 5.6 2.508 5.6 5.6 0 3.093-2.507 5.6-5.6 5.6-3.093 0-5.6-2.507-5.6-5.6 0-3.092 2.507-5.6 5.6-5.6z",
  transform: "translate(0 2)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M16.237 78.509l-3.256.457c-1.75.246-3.369-.973-3.615-2.723L.46 12.866c-.246-1.75.974-3.369 2.724-3.615L65.768.456c1.75-.246 3.368.973 3.614 2.723l.765 5.446",
  transform: "translate(0 2) translate(39.186)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8F0FE",
  d: "M18.258 74.98l-2.957.42c-1.589.226-3.056-.879-3.277-2.467l-7.996-57.54c-.22-1.59.888-3.06 2.478-3.286l56.83-8.078c1.589-.226 3.056.88 3.277 2.468l.687 4.945 7.365 53.279c.244 1.77-.976 3.405-2.727 3.653l-.056.007-53.624 6.6z",
  transform: "translate(0 2) translate(39.186)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#75A4FE",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M16.237 78.509l-3.256.457c-1.75.246-3.369-.973-3.615-2.723L.46 12.866c-.246-1.75.974-3.369 2.724-3.615L65.768.456c1.75-.246 3.368.973 3.614 2.723l.765 5.446M70.814 12.314L71.214 14.81",
  transform: "translate(0 2) translate(39.186)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 2) translate(57.727 11.759)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#75A4FE",
  strokeWidth: 2,
  d: "M73.802 8.49L10.948 1.884c-.604-.063-1.177.124-1.614.478-.438.355-.74.876-.804 1.48l-6.69 63.65c-.063.604.124 1.177.478 1.614.355.438.876.74 1.48.804l62.854 6.606c.604.063 1.177-.124 1.614-.478.438-.355.74-.876.804-1.48l6.69-63.65c.063-.604-.124-1.177-.478-1.614-.355-.438-.876-.74-1.48-.804z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M16.665 8.72l50.124 5.268c1.318.138 2.274 1.319 2.136 2.637l-4.432 42.168c-.139 1.318-1.32 2.274-2.638 2.136L11.731 55.66c-1.318-.139-2.274-1.32-2.136-2.638l4.432-42.168c.139-1.318 1.32-2.274 2.638-2.136z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8F0FE",
  d: "M16.465 43.354l7.838-5.287c1.307-.881 3.061-.68 4.134.475l5.74 6.179c.286.308.762.342 1.089.077l12.272-9.944c1.373-1.112 3.388-.901 4.5.472.073.089.14.181.202.277l7.984 12.35 1.147 1.914-.55 6.5c-.036.44-.423.766-.864.73l-.02-.003-45.57-5.063c-.434-.048-.75-.434-.71-.868l.605-6.56 2.203-1.25z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#75A4FE",
  strokeWidth: 2,
  d: "M66.684 14.982L16.56 9.714c-.384-.04-.749.079-1.027.304-.279.226-.47.557-.511.942L10.59 53.128c-.04.384.078.748.304 1.027.225.278.557.47.942.511l50.124 5.268c.384.04.748-.078 1.027-.304.278-.225.47-.557.511-.942l4.432-42.167c.04-.385-.079-.75-.304-1.028-.226-.278-.557-.47-.942-.511z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.298,
  cy: 24.211,
  r: 4.8,
  fill: "#E8F0FE",
  stroke: "#75A4FE",
  strokeWidth: 2,
  transform: "rotate(6 26.298 24.211)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#75A4FE",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M14.856 44.591l9.447-6.524c1.307-.881 3.061-.68 4.134.475l5.74 6.179c.286.308.762.342 1.089.077l12.272-9.944c1.373-1.112 3.388-.901 4.5.472.073.089.14.181.202.277l8.85 14.045"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeedEmpty);
export default ForwardRef;